module.exports = __webpack_public_path__ + "img/facebook-icon.79229573.svg";